import Image from 'next/image'
import React, { useEffect, useRef } from 'react'
import imageLoader from '../imageLoader';
import Link from 'next/link';

const Footer = ({ scrollToPioneers, scrollToProduct, scrollToContact, scrollToFacts, setRefToContactSend }: any) => {
    const scrollToTop = () => {
        if(window) {
      
          window.scrollTo({top: 0, behavior: 'smooth'});
          return
          // return refToModa?.current.scrollIntoView({behavior: 'smooth'})
        }
    }
    const rowRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if(rowRef != null && setRefToContactSend != null) {
        setRefToContactSend(rowRef)
      } 
  }, []) 

  return (
    <footer className='h-full w-full bg-black md:px-4 pb-1' ref={rowRef}>
        <div className='h-full w-full flex flex-col'>
        <div className='w-full h-20 flex flex-col justify-center items-center bg-black mt-12'>
                <h5 className='text-white cursor-pointer text-3xl md:text-4xl mb-2'>Contact Us</h5>
                <a href= "mailto: >sales@evawagyu.com" className='lightYellow text-sm md:text-lg cursor-pointer'>sales@evawagyu.com</a>
            </div>
            <div className='w-full h-40 bg-black flex justify-center items-center mt-8'>
            <Image
                alt='icon image'
                src="/images/wagyu/Logo_Wagyu_footer.png"
                width={180}
                height={180}
                loader={imageLoader}
                className="cursor-pointer object-contain transition duration-500 hover:scale-105 opacity-90 hover:opacity-100"
                />
            </div>
            <div className='w-full h-auto mb-8 flex flex-row justify-center items-start md:items-center bg-black'>
                <p className='text-gray-500 cursor-pointer' onClick={() => scrollToTop()}>Back to Top</p>
            </div>
            <div className='w-full h-auto flex flex-row justify-center space-x-4 md:space-x-6 items-center pr-6 md:p-0 bg-black'>
                <h6 className='text-sm md:text-lg font-light text-white cursor-pointer text-center' onClick={scrollToPioneers}>WAGYU PIONEERS</h6>
                <h6 className='text-sm md:text-lg font-light text-white cursor-pointer text-center' onClick={scrollToProduct}>PRODUCT</h6>
                <h6 className='text-sm md:text-lg font-light text-white cursor-pointer  text-center' onClick={scrollToFacts}>FACTS</h6>
                <a href= "mailto: >sales@evawagyu.com" className='text-sm md:text-lg font-light text-white cursor-pointer text-center'>CONTACT US</a>
            </div>
            <div className='w-full h-20 bg-black flex justify-center items-center'>
                <h6 className='text-sm font-light text-white'>@ 2023 WAGYU</h6>
            </div>
        </div>
            <div className='w-full h-auto bg-transparent flex justify-end items-center relative bottom-1 md:bottom-12 md:right-10 mx-auto text-center md:text-end'>
              <a href="https://www.agenciaagro.com" target="_blank" className='w-full '> 
                <h6 className='text-xs font-light text-white'>AGENCIAAGRO</h6>
              </a>
            </div>
    </footer>
  )
}

export default Footer